export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5324.91e2de34.jpg";